import {createSelector} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {ISickDaysState} from '@app/core/store/state/sick-days.state';

const _selectSickDays = (state: IAppState) => state.sickDays;

export const selectIsSickDaysLoading = createSelector(
	_selectSickDays,
	(state: ISickDaysState) => state.isLoading,
);
export const selectSickDays = createSelector(
	_selectSickDays,
	(state: ISickDaysState) => state.sickDays,
);
export const selectSickDayAnswers = createSelector(
	_selectSickDays,
	(state: ISickDaysState) => state.answers,
);
